// extracted by mini-css-extract-plugin
module.exports = {"blackTwo":"#222","desktop":"1200px","mobile":"970px","progressionCicleBorder":"#c8c8c8","purple":"#8850ff","radarChartBorder":"#c8c8c8","tablet":"1024px"};